module.exports = __webpack_public_path__ + "media/images/v2/prezi_logo-da0fb381251511af0bcd214ebf3cf732.png";